import { jsx as _jsx } from "react/jsx-runtime";
import TabsControlled from "./TabsControlled.js";
import TabsUncontrolled from "./TabsUncontrolled.js";
import TabsItem from "./TabsItem.js";
import TabsList from "./TabsList.js";
import TabsPanel from "./TabsPanel.js";
const Tabs = (props) => {
    const { value } = props;
    if (value !== undefined)
        return _jsx(TabsControlled, { ...props });
    return _jsx(TabsUncontrolled, { ...props });
};
Tabs.Item = TabsItem;
Tabs.List = TabsList;
Tabs.Panel = TabsPanel;
Tabs.displayName = "Tabs";
export default Tabs;
